/* Go Kids scroll reveals — DS motion spec: <=350ms, ease-out, small translateY.
   Elements opt in with [data-gk-reveal]; siblings inside a [data-gk-reveal-group]
   stagger by 60ms. IntersectionObserver drives reveals, with a rect-based sweep
   as a safety net so nothing can stay hidden. No-ops for reduced motion. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var pending = [];

  function reveal(el) {
    el.classList.add('gk-reveal-in');
    var i = pending.indexOf(el);
    if (i > -1) pending.splice(i, 1);
  }

  function sweep() {
    for (var i = pending.length - 1; i >= 0; i--) {
      var rect = pending[i].getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.96 && rect.bottom > 0) reveal(pending[i]);
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-gk-reveal]');
    if (!els.length) return;

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -4% 0px', threshold: 0.05 }
      );
    }

    els.forEach(function (el) {
      var group = el.closest('[data-gk-reveal-group]');
      if (group) {
        var peers = group.querySelectorAll('[data-gk-reveal]');
        var index = Array.prototype.indexOf.call(peers, el);
        el.style.setProperty('--gk-reveal-delay', (index % 8) * 60 + 'ms');
      }
      el.classList.add('gk-reveal-init');
      pending.push(el);
      if (io) io.observe(el);
    });

    var ticking = false;
    function onScroll() {
      if (ticking || !pending.length) return;
      ticking = true;
      requestAnimationFrame(function () {
        sweep();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setTimeout(sweep, 400);
    setTimeout(sweep, 1500);
    setTimeout(sweep, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
